import { initState } from './store';

const configureNavStore = () => {
    const actions = {
        SET_NAV_PATH: (currentState, payload) => {
            return { navPath: payload.path };
        },
    }

    initState(actions, { navPath: null });
}

export default configureNavStore;